
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { useState, useEffect, useRef, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import {
  BsBagCheck,
  BsTruck,
  BsPatchCheck,
  BsHeadset,
  BsClipboardCheck,
  BsArrowsFullscreen,
  BsPlus
} from "react-icons/bs";
import { SlArrowLeftCircle, SlArrowRightCircle } from "react-icons/sl";
import { FaAngleDown } from "react-icons/fa";
import { MyContext } from './context/UserProvider';
import CaracteristicasProduto from '../layout/CaracteristicasProduto';

import CadastroScreen from './CadastroScreen';
import ImageWithLoader from '../layout/ImageWithLoader';
import Preloader from '../layout/Preloader';
import { AnimatePresence } from 'framer-motion';



export default function Produto() {
  const location = useLocation();
  const { id } = useParams(); // pega /Produto/:id
  const [showTelaGrande, setShowTelaGrande] = useState(false)
  const [imagemGrande, setImagemGrande] = useState()

  const [clicado, setClicado] = useState(false);
  const [zoomStyle, setZoomStyle] = useState({}); // Para armazenar o estilo de zoom
  const [imagemSelecionada, setImagemSelecionada] = useState(null);
  const [showZoom, setShowZoom] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // produto_id agora prioriza o id da rota; fallback para localStorage
  const produto_id = id ?? localStorage.getItem('produto_id');
  const categoria_id = localStorage.getItem('categoria_id');

  const [produto1, setProduto1] = useState(null);
  const [imagemPrincipal, setImagemPrincipal] = useState();
  const [imagensProdutos, setImagensProdutos] = useState([]);
  const [windowDimensions, setWindowDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [parcelaSelecionada, setParcelaSelecionada] = useState(6);
  const [parcelaHover, setParcelaHover] = useState(null);
  const [visivel, setVisivel] = useState(false);
  const [showValor, setShowValor] = useState(false);
  const [mostrarDetalhesPix, setMostrarDetalhesPix] = useState(false);


  const [preco, setPreco] = useState('');
  const [tamanhoSelecionado, setTamanhoSelecionado] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const navigate = useNavigate();

  // controla o prompt central "Já possui uma conta?"
  const [showAccountPrompt, setShowAccountPrompt] = useState(false);
  const scrollContainerRef = useRef(null);
  const insercaoEmAndamentoRef = useRef(false);


  const [imagemRelacionados, setImagemRelacionados] = useState([]);

  const {
    showCadastroInProduto, setShowCadastroInProduto,

    tecidoId, setTecidoId,
    setShowUser,
    setShowTelaLogin,
    setShowOrcamento,
    setOrcamentosSelecionados,
    scrollY, setScrollY,
    opcaoDeParcela, setOpcaoDeParcela
  } = useContext(MyContext);

  // sincroniza localStorage quando navegamos para /Produto/:id
  useEffect(() => {
    if (id) {
      localStorage.setItem('produto_id', id);
    }
  }, [id]);
  const imgWidth = '100%';  // Largura fixa para as imagens
  const imgHeight = '90vh';

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const containerWidth = container.offsetWidth;
      const maxScrollLeft = container.scrollWidth - containerWidth;
      // Verifica se a rolagem já está na última imagem
      if (container.scrollLeft >= maxScrollLeft) {
        // Teleporta para a primeira imagem sem animação
        container.scrollLeft = 0;
      } else {
        container.scrollBy({ left: containerWidth, behavior: 'smooth' });
      }
    }
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const containerWidth = container.offsetWidth;
      // Verifica se já está na primeira imagem
      if (container.scrollLeft <= 0) {
        // Teleporta para a última imagem sem animação
        container.scrollLeft = container.scrollWidth - containerWidth;
      } else {
        container.scrollBy({ left: -containerWidth, behavior: 'smooth' });
      }
    }
  };
  const [loading, setLoading] = useState(true);

  // O useEffect para chamar a função getInfoProduto e escutar redimensionamento da janela
  useEffect(() => {
    // getInfoProduto now handles loading state internally or we wrap it
    // But since getInfoProduto is a function defined below, and it's used elsewhere, 
    // let's modify getInfoProduto to return a promise so we can wait for it here if we want, 
    // OR just modify getInfoProduto itself. 

    // Simplest: call a wrapper that manages loading
    const loadAll = async () => {
      setLoading(true);
      await Promise.all([
        getInfoProduto(),

      ]);
      setTimeout(() => setLoading(false), 800);
    }

    loadAll();

    setScrollY(1);

    // Função para atualizar as dimensões da janela
    const handleResize = () => {
      setWindowDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    // Chama handleResize no carregamento inicial
    handleResize();

    // Adiciona o listener para o resize da janela
    window.addEventListener('resize', handleResize);

    // Limpeza: remove o listener quando o componente for desmontado
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [id]); // roda quando o id da rota muda




  const getInfoProduto = () => {
    const toSearch = { produto_id: produto_id };

    const apiBase = process.env.REACT_APP_API_URL;

    return fetch(`${apiBase}/api/getInfoProduto`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        setProduto1(json);
        setImagemPrincipal(json.imagem_urls ? json.imagem_urls[0] : '');
        setImagensProdutos(json.imagem_urls || []);

        const tamanhosValidos = Array.isArray(json.tamanhos)
          ? json.tamanhos
            .map((valor) => Number(valor))
            .filter((valor) => Number.isInteger(valor) && valor > 0)
          : [];

        const tamanhoInicial = tamanhosValidos[0] ?? null;
        // O backend fornece o preço final por tamanho (incluindo as poltronas, quando aplicável).
        const precoFinal = Number(json.precos_por_tamanho?.[tamanhoInicial]);

        setTamanhoSelecionado(tamanhoInicial);

        if (
          tamanhoInicial &&
          Number.isFinite(precoFinal) &&
          precoFinal > 0
        ) {
          setPreco(precoFinal);
          setShowValor(true);
        } else {
          setPreco('');
          setShowValor(false);
        }


        // se a API retornou categoria, sincroniza e busca relacionados com essa categoria
        const cat = json.categoria_id ?? categoria_id;
        if (cat) {
          localStorage.setItem('categoria_id', cat);
          // chama relacionados com a categoria correta
          getProdutosRelacionados(cat);
        } else {
          // fallback: busca relacionados com o categoria_id atual do localStorage
          getProdutosRelacionados(categoria_id);
        }
      })
      .catch((error) => {
        console.error('Erro na requisição:', error);
      });
  };



  const insertOrcamentoRoyal = (comprarAgora = false) => {
    if (insercaoEmAndamentoRef.current) return;

    const usuario = JSON.parse(localStorage.getItem("usuario"));
    const usuario_id = usuario?.usuario_id;

    if (!usuario_id) {
      console.error("Usuário não encontrado no localStorage");
      return;
    }

    if (!produto1 || !produto1.produto_id) {
      console.error("produto1 não definido");
      return;
    }

    const tamanhosPermitidos = Array.isArray(produto1.tamanhos)
      ? produto1.tamanhos.map((valor) => Number(valor))
      : [];

    if (
      !tamanhoSelecionado ||
      !tamanhosPermitidos.includes(Number(tamanhoSelecionado))
    ) {
      alert("Selecione um tamanho disponível antes de adicionar ao orçamento!");
      return;
    }

    const tecido_id = 90;
    const cor_id = 1;

    const toSend = {
      produto_id: produto1.produto_id,
      usuario_id,
      tecido_id,
      cor_id,
      tamanho_cm: Number(tamanhoSelecionado),
    };

    const apiBase = process.env.REACT_APP_API_URL;

    insercaoEmAndamentoRef.current = true;

    fetch(`${apiBase}/api/insertOrcamentoRoyal`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(toSend),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        if (json.success) {
          if (comprarAgora) {
            const novoOrcamentoId = Number(json.orcamento_id);

            if (
              !Number.isSafeInteger(novoOrcamentoId) ||
              novoOrcamentoId <= 0
            ) {
              alert("Produto adicionado, mas não foi possível identificar o item para compra.");
              return;
            }

            // Seleciona somente a unidade recém-criada.
            setOrcamentosSelecionados([novoOrcamentoId]);

            // Abre diretamente o carrinho, sem o modal de sucesso.
            setShowSuccess(false);
            setShowOrcamento(true);
          } else {
            // Mantém o comportamento original.
            setShowSuccess(true);
          }
        } else {
          alert("Falha ao criar orçamento");
        }
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
      })
      .finally(() => {
        insercaoEmAndamentoRef.current = false;
      });
  };



  // getProdutosRelacionados agora aceita catId opcional
  const getProdutosRelacionados = (catId) => {
    const toSearch = { categoria_id: catId ?? categoria_id };

    const apiBase = process.env.REACT_APP_API_URL;

    fetch(`${apiBase}/api/getProdutosRelacionados`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        const relacionadosFiltrados = (Array.isArray(json) ? json : [])
          // remove o produto que está aberto atualmente
          .filter(
            (item) =>
              String(item.produto_id) !== String(produto_id)
          )

          // remove produtos duplicados
          .filter(
            (item, index, array) =>
              index ===
              array.findIndex(
                (outro) =>
                  String(outro.produto_id) ===
                  String(item.produto_id)
              )
          );

        setImagemRelacionados(relacionadosFiltrados);
        setStartIndex(0);
      })
      .catch((error) => {
        console.error('Erro na requisição:', error);
      });
  };




  const handleSelecionarTamanho = (tamanho) => {
    const tamanhoNum = Number(tamanho);
    const precoFinal = Number(produto1?.precos_por_tamanho?.[tamanhoNum]);

    if (!Number.isInteger(tamanhoNum) || tamanhoNum <= 0) return;

    setTamanhoSelecionado(tamanhoNum);

    if (Number.isFinite(precoFinal) && precoFinal > 0) {
      setPreco(precoFinal);
      setShowValor(true);
    } else {
      setPreco('');
      setShowValor(false);
    }
  };


  const formatarPreco = (valor, preco) =>
    Number(valor ?? preco).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  // Prévia visual. O desconto efetivo deve ser validado pelo backend.
  const precoPixEstimado = showValor && Number(preco) > 0
    ? Math.round(Number(preco) * 0.9 * 100) / 100
    : null;



  const opcoes = Array.from({ length: 6 }, (_, i) => i + 1);

  const handleNext = () => {
    if (imagemRelacionados.length > 0) {
      setStartIndex((prevIndex) => {
        // Avança para o próximo conjunto de 3 imagens, e volta para o início se atingir o final
        return (prevIndex + 1) % imagemRelacionados.length;
      });
    }
  };

  const handlePrev = () => {
    if (imagemRelacionados.length > 0) {
      setStartIndex((prevIndex) => {
        // Retrocede para o conjunto anterior de 3 imagens, e vai para o final se estiver no início
        return (prevIndex - 1 + imagemRelacionados.length) % imagemRelacionados.length;
      });
    }
  };

  // Função para garantir que sempre mostre 3 imagens
  const getImagesToShow = () => {
    if (imagemRelacionados.length > 0) {
      const nextImages = [];

      const quantidadeDesejada =
        windowDimensions.width >= 1200
          ? 5
          : windowDimensions.width >= 768
            ? 3
            : 2;

      // nunca tenta mostrar mais produtos
      // do que realmente existem
      const quantidade = Math.min(
        quantidadeDesejada,
        imagemRelacionados.length
      );

      for (let i = 0; i < quantidade; i++) {
        const index =
          (startIndex + i) %
          imagemRelacionados.length;

        nextImages.push(
          imagemRelacionados[index]
        );
      }

      return nextImages;
    }

    return [];
  };


  const handleMouseMove = (e) => {
    setShowZoom(true);
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const mouseX = e.clientX - left;
    const mouseY = e.clientY - top;

    const zoomX = (mouseX / width) * 100;
    const zoomY = (mouseY / height) * 100;

    setZoomStyle({
      backgroundImage: `url(${imagemPrincipal})`,
      backgroundSize: '500%',
      backgroundPosition: `${zoomX}% ${zoomY}%`,
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 10,
    });
  };
  const selectImage = (index) => {
    setImagemPrincipal(imagensProdutos[index]);
  };

  const handleMouseLeave = () => {
    setShowZoom(false);
    setZoomStyle({});
  };

  const alterarImagemPrincipal = (novaImagem) => {
    setImagemPrincipal(novaImagem);
  };

  const handleMouseEnterImagem = (imagem) => {
    setImagemSelecionada(imagem);
    setImagemPrincipal(imagem);

  };

  const handleClick = (texto) => {
    const rota = texto.trim();
    navigate(`/${rota}`);
  };






  const isMobile = windowDimensions.width < 1508;
  const isTablet = windowDimensions.width >= 1508 && windowDimensions.width < 1180;
  const maxContentWidth = 1480;

  const modulosDisponiveis = [
    'valor_opcoes_modulos_70', 'valor_opcoes_modulos_80', 'valor_opcoes_modulos_90',
    'valor_opcoes_modulos_100', 'valor_opcoes_modulos_110', 'valor_opcoes_modulos_120',
    'valor_opcoes_modulos_130', 'valor_opcoes_modulos_140', 'valor_opcoes_modulos_165',
    'valor_opcoes_modulos_185', 'valor_opcoes_modulos_205', 'valor_opcoes_modulos_225'
  ]
    .map((key) => produto1?.[key])
    .filter((value) => value !== null && value !== undefined && value !== '');

  const handleAdicionarAoOrcamento = () => {
    const usuario = JSON.parse(localStorage.getItem('usuario'));
    const usuario_id = usuario?.usuario_id;

    if (!usuario_id) {
      setShowAccountPrompt(true);
      return;
    }

    setClicado(!clicado);
    insertOrcamentoRoyal();
  };

  const handleComprarAgora = () => {
    const usuario = JSON.parse(localStorage.getItem('usuario'));
    const usuario_id = usuario?.usuario_id;

    if (!usuario_id) {
      setShowAccountPrompt(true);
      return;
    }

    insertOrcamentoRoyal(true);
  };



  const tecidoSwatches = [
    { nome: 'Terracota', cor: '#b96843' },
    { nome: 'Areia', cor: '#d8cbb8' },
    { nome: 'Grafite', cor: '#54514d' },
    { nome: 'Oliva', cor: '#6f7251' },
    { nome: 'Marinho', cor: '#28384a' },
    { nome: 'Off White', cor: '#eee9df' },
  ];

  const trustItems = [
    {
      icon: <BsTruck />,
      title: 'Entrega para',
      text: 'todo o Brasil'
    },
    {
      icon: <BsPatchCheck />,
      title: 'Qualidade nos',
      text: 'detalhes e estrutura'
    },
    {
      icon: <BsHeadset />,
      title: 'Atendimento',
      text: 'consultivo'
    },
    {
      icon: <BsClipboardCheck />,
      title: 'Orçamento',
      text: 'simples e seguro'
    },
  ];

  return (
    <div
      translate="no"
      style={{
        backgroundColor: '#fbfaf8',
        width: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        color: '#211c18',
      }}
    >
      <AnimatePresence>
        {loading && <Preloader key="preloader" />}
      </AnimatePresence>

      {!loading && produto1 && (
        <>


          {showSuccess && (
            <div
              style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 11000,
                minHeight: '100vh',
                backgroundColor: 'rgba(30,24,20,0.38)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                padding: '1rem',
                boxSizing: 'border-box',
              }}
              role="dialog"
              aria-modal="true"
              onClick={() => setShowSuccess(false)}
            >
              <div
                style={{
                  width: 420,
                  maxWidth: '92%',
                  background: '#fff',
                  borderRadius: 16,
                  border: '1px solid #e7e0d7',
                  boxShadow: '0 20px 60px rgba(49,39,31,0.18)',
                  padding: 24,
                  textAlign: 'center',
                  boxSizing: 'border-box',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3
                  style={{
                    margin: 0,
                    marginBottom: 8,
                    fontSize: 20,
                    fontWeight: 500
                  }}
                >
                  Adicionado ao Carrinho
                </h3>

                <p
                  style={{
                    margin: 0,
                    marginBottom: 20,
                    color: '#6f675f',
                    fontSize: 14,
                    lineHeight: 1.5
                  }}
                >
                  Seu produto foi adicionado. Deseja continuar navegando ou finalizar o orçamento?
                </p>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setShowSuccess(false)}
                    style={{
                      padding: '11px 18px',
                      borderRadius: 999,
                      border: '1px solid #6a5242',
                      background: '#fff',
                      color: '#4c392e',
                      cursor: 'pointer',
                      fontWeight: 500,
                    }}
                  >
                    Continuar navegando
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setShowSuccess(false);
                      setOrcamentosSelecionados([]);
                      setShowOrcamento(true);
                    }}
                    style={{
                      padding: '11px 18px',
                      borderRadius: 999,
                      border: '1px solid #5f4738',
                      background: '#5f4738',
                      color: '#fff',
                      cursor: 'pointer',
                      fontWeight: 500,
                    }}
                  >
                    Finalizar orçamento
                  </button>
                </div>
              </div>
            </div>
          )}

          {showAccountPrompt && (
            <div
              style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 11000,
                minHeight: '100vh',
                backgroundColor: 'rgba(30,24,20,0.38)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
                padding: '1rem',
                boxSizing: 'border-box',
              }}
              role="dialog"
              aria-modal="true"
              onClick={() => setShowAccountPrompt(false)}
            >
              <div
                style={{
                  width: 420,
                  maxWidth: '92%',
                  background: '#fff',
                  borderRadius: 16,
                  border: '1px solid #e7e0d7',
                  boxShadow: '0 20px 60px rgba(49,39,31,0.18)',
                  padding: 24,
                  textAlign: 'center',
                  boxSizing: 'border-box',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3
                  style={{
                    margin: 0,
                    marginBottom: 8,
                    fontSize: 20,
                    fontWeight: 500
                  }}
                >
                  Já possui uma conta?
                </h3>

                <p
                  style={{
                    margin: 0,
                    marginBottom: 20,
                    color: '#6f675f',
                    fontSize: 14
                  }}
                >
                  Faça login para continuar ou crie sua conta.
                </p>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    justifyContent: 'center'
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      setShowUser(true);
                      setShowTelaLogin(true);
                      setShowAccountPrompt(false);
                    }}
                    style={{
                      padding: '11px 20px',
                      borderRadius: 999,
                      border: '1px solid #5f4738',
                      background: '#5f4738',
                      color: '#fff',
                      cursor: 'pointer',
                      fontWeight: 500,
                    }}
                  >
                    Entrar
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setShowAccountPrompt(false);
                      setShowCadastroInProduto(true);
                    }}
                    style={{
                      padding: '11px 20px',
                      borderRadius: 999,
                      border: '1px solid #6a5242',
                      background: '#fff',
                      color: '#4c392e',
                      cursor: 'pointer',
                      fontWeight: 500,
                    }}
                  >
                    Criar conta
                  </button>
                </div>
              </div>
            </div>
          )}

          {showCadastroInProduto && (
            <>
              <div
                onClick={() => setShowCadastroInProduto(false)}
                style={{
                  position: 'fixed',
                  inset: 0,
                  zIndex: 9999,
                  backdropFilter: 'blur(6px)',
                  WebkitBackdropFilter: 'blur(6px)',
                  backgroundColor: 'rgba(30,24,20,0.38)',
                  cursor: 'pointer',
                }}
                aria-hidden="true"
              />

              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: isMobile ? '92vw' : '760px',
                  maxHeight: '88vh',
                  position: 'fixed',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  background: '#fff',
                  zIndex: 10000,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  boxSizing: 'border-box',
                  borderRadius: 18,
                  boxShadow: '0 24px 70px rgba(40,30,24,0.2)',
                }}
                role="dialog"
                aria-modal="true"
              >
                <CadastroScreen />
              </div>
            </>
          )}

          {showTelaGrande && (
            <div
              onClick={() => setShowTelaGrande(false)}
              style={{
                position: 'fixed',
                inset: 0,
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(24,20,17,0.72)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                padding: 20,
              }}
            >
              <img
                src={imagemGrande}
                alt="ampliada"
                onClick={(e) => e.stopPropagation()}
                style={{
                  maxWidth: '92vw',
                  maxHeight: '90vh',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: 12,
                  boxShadow: '0 18px 60px rgba(0,0,0,0.45)',
                  userSelect: 'none',
                }}
              />
            </div>
          )}

          <Navbar />

          <main
            style={{
              width: '100%',
              maxWidth: maxContentWidth,
              margin: '0 auto',
              padding: isMobile
                ? '14px 12px 34px'
                : isTablet
                  ? '22px 22px 48px'
                  : '28px 34px 56px',
              boxSizing: 'border-box',
            }}
          >
            {!isMobile && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 9,
                  marginBottom: 18,
                  color: '#8a8178',
                  fontSize: 12,
                }}
              >
                <span
                  onClick={() => handleClick('')}
                  style={{ cursor: 'pointer' }}
                >
                  Início
                </span>

                <span>›</span>

                <span
                  onClick={() => {
                    localStorage.setItem(
                      'categoria_id',
                      produto1.categoria_id
                    );

                    navigate(
                      '/produtos/' + produto1.categoria_id
                    );
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Sofás
                </span>

                <span>›</span>

                <span
                  style={{
                    color: '#2b251f',
                    fontWeight: 500
                  }}
                >
                  {produto1.produto_nome}
                </span>
              </div>
            )}

            <section
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile
                  ? '1fr'
                  : windowDimensions.width < 1508
                    ? '1fr'
                    : 'minmax(0, 1.68fr) minmax(360px, 0.68fr)',
                gap: isMobile
                  ? 22
                  : isTablet
                    ? 22
                    : 28,
                alignItems: 'start',
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    display: isMobile ? 'flex' : 'grid',
                    flexDirection: 'column',
                    gridTemplateColumns: '76px minmax(0, 1fr)',
                    gap: isMobile ? 10 : 14,
                    minWidth: 0,
                  }}
                >
                  {!isMobile && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 9,
                        maxHeight: 610,
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                      }}
                    >
                      {imagensProdutos.map((imagem, index) => (
                        <button
                          key={index}
                          type="button"
                          onMouseEnter={() =>
                            handleMouseEnterImagem(imagem)
                          }
                          onClick={() =>
                            alterarImagemPrincipal(imagem)
                          }
                          style={{
                            width: 74,
                            height: 74,
                            padding: 0,
                            borderRadius: 7,
                            overflow: 'hidden',
                            border:
                              imagem === imagemPrincipal
                                ? '1.5px solid #5f4738'
                                : '1px solid #e4ddd4',
                            background: '#f4f1ed',
                            cursor: 'pointer',
                            flex: '0 0 auto',
                          }}
                        >
                          <ImageWithLoader
                            src={imagem}
                            alt={`Imagem ${index + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              display: 'block',
                              objectFit: 'cover',
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  )}

                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        position: 'relative',
                        width: '100%',
                        aspectRatio: isMobile
                          ? '4 / 3'
                          : '4 / 3',
                        overflow: 'hidden',
                        borderRadius: isMobile ? 0 : 8,
                        background: '#f2efeb',
                        cursor: isMobile
                          ? 'zoom-in'

                          : 'crosshair',
                      }}
                      onMouseMove={
                        !isMobile
                          ? handleMouseMove
                          : undefined
                      }
                      onMouseLeave={
                        !isMobile
                          ? handleMouseLeave
                          : undefined
                      }
                      onClick={() => {
                        if (isMobile) {
                          setShowTelaGrande(true);
                          setImagemGrande(imagemPrincipal);
                        }
                      }}
                    >
                      <ImageWithLoader
                        src={imagemPrincipal}
                        alt={produto1.produto_nome}
                        style={{
                          display: 'block',
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          backgroundColor: '#f2efeb',
                        }}
                      />

                      {!isMobile && showZoom && (
                        <div
                          style={{
                            ...zoomStyle,
                            position: 'absolute',
                            inset: 0,
                            zIndex: 5,
                          }}
                        />
                      )}

                      {!isMobile && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowTelaGrande(true);
                            setImagemGrande(imagemPrincipal);
                          }}
                          style={{
                            position: 'absolute',
                            top: 14,
                            right: 14,
                            width: 38,
                            height: 38,
                            borderRadius: '50%',
                            border: '1px solid rgba(83,68,56,0.15)',
                            background: 'rgba(255,255,255,0.92)',
                            color: '#3f332a',
                            cursor: 'pointer',
                            zIndex: 7,
                            fontSize: 17,
                          }}
                          aria-label="Ampliar imagem"
                        >
                          <BsArrowsFullscreen />
                        </button>
                      )}
                    </div>

                    {isMobile && (
                      <div
                        style={{
                          display: 'flex',
                          gap: 8,
                          overflowX: 'auto',
                          paddingTop: 10,
                          scrollbarWidth: 'none',
                        }}
                      >
                        {imagensProdutos.map((imagem, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() =>
                              alterarImagemPrincipal(imagem)
                            }
                            style={{
                              width: 64,
                              height: 64,
                              padding: 0,
                              borderRadius: 6,
                              overflow: 'hidden',
                              border:
                                imagem === imagemPrincipal
                                  ? '1.5px solid #5f4738'
                                  : '1px solid #e4ddd4',
                              background: '#f4f1ed',
                              cursor: 'pointer',
                              flex: '0 0 auto',
                            }}
                          >
                            <ImageWithLoader
                              src={imagem}
                              alt={`Imagem ${index + 1}`}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block'
                              }}
                            />
                          </button>
                        ))}
                      </div>
                    )}

                    {isMobile && (
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gap: 8,
                          marginTop: 14,
                          width: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        {trustItems.map((item) => (
                          <div
                            key={item.title}
                            style={{
                              border: '1px solid #ebe4dc',
                              borderRadius: 8,
                              padding: 10,
                              background: '#fff',
                              boxSizing: 'border-box',
                            }}
                          >
                            <div
                              style={{
                                fontSize: 15,
                                color: '#5f4738'
                              }}
                            >
                              {item.icon}
                            </div>

                            <div
                              style={{
                                marginTop: 5,
                                fontSize: 10,
                                color: '#4d4239'
                              }}
                            >
                              {item.title}
                            </div>

                            <div
                              style={{
                                marginTop: 2,
                                fontSize: 9,
                                color: '#8a8076'
                              }}
                            >
                              {item.text}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {!isMobile && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(4, 1fr)',
                      marginTop: 18,
                      borderTop: '1px solid #e9e3dc',
                      borderBottom: '1px solid #e9e3dc',
                      background: '#fcfbf9',
                    }}
                  >
                    {trustItems.map((item, index) => (
                      <div
                        key={item.title}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 10,
                          minHeight: 76,
                          padding: '10px 12px',
                          boxSizing: 'border-box',
                          borderRight:
                            index < trustItems.length - 1
                              ? '1px solid #e9e3dc'
                              : 'none',
                        }}
                      >
                        <span
                          style={{
                            fontSize: 19,
                            color: '#5f4738'
                          }}
                        >
                          {item.icon}
                        </span>

                        <div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#40362e'
                            }}
                          >
                            {item.title}
                          </div>

                          <div
                            style={{
                              fontSize: 11,
                              color: '#81776e',
                              marginTop: 2
                            }}
                          >
                            {item.text}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <aside
                style={{
                  minWidth: 0,
                  background: '#fbfaf8',
                  padding: isMobile ? '4px 2px 0' : '4px 0 0',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: 18,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 10,
                        letterSpacing: '0.28em',
                        textTransform: 'uppercase',
                        color: '#8c8177',
                        marginBottom: 9,
                      }}
                    >
                      Royal Sofás
                    </div>

                    <h1
                      style={{
                        fontFamily: 'Georgia, Times New Roman, serif',
                        fontSize: isMobile
                          ? 34
                          : isTablet
                            ? 38
                            : 44,
                        lineHeight: 1.02,
                        fontWeight: 400,
                        letterSpacing: '-0.03em',
                        margin: 0,
                        color: '#241e19',
                      }}
                    >
                      {produto1.produto_nome}
                    </h1>
                  </div>

                  <BsBagCheck
                    style={{
                      fontSize: 24,
                      marginTop: 12,
                      color: clicado
                        ? '#6c7a53'
                        : '#55483e',
                      flex: '0 0 auto',
                    }}
                  />
                </div>

                <p
                  style={{
                    margin: '13px 0 0',
                    fontSize: 14,
                    lineHeight: 1.55,
                    color: '#655c54',
                    maxWidth: 620,
                  }}
                >
                  {produto1.produto_descricao}
                </p>

                <div
                  style={{
                    height: 1,
                    background: '#e4ddd5',
                    margin: '19px 0'
                  }}
                />

                {showValor && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: isMobile
                        ? '1fr'
                        : 'minmax(0,1fr) 190px',
                      gap: 14,
                      alignItems: 'stretch',
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontFamily:
                            'Georgia, Times New Roman, serif',
                          fontSize: isMobile ? 34 : 38,
                          letterSpacing: '-0.02em',
                          color: '#241e19',
                        }}
                      >
                        {formatarPreco(preco)}
                      </div>

                      <div
                        style={{
                          marginTop: 5,
                          fontSize: 13,
                          color: '#6d6259'
                        }}
                      >
                        ou em até{' '}
                        <strong>
                          {parcelaSelecionada}x de{' '}
                          {formatarPreco(
                            preco / parcelaSelecionada
                          )}
                        </strong>
                      </div>
                    </div>

                    <div
                      onMouseEnter={() =>
                        setVisivel(true)
                      }
                      onMouseLeave={() =>
                        setVisivel(false)
                      }
                      onClick={() =>
                        setVisivel(!visivel)
                      }
                      style={{
                        position: 'relative',
                        border: '1px solid #e1d9d0',
                        borderRadius: 9,
                        background: '#f3eee8',
                        padding: '10px 12px',
                        cursor: 'pointer',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div
                        style={{
                          fontSize: 10,
                          color: '#80766c',
                          marginBottom: 5
                        }}
                      >
                        Parcelamento
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 8,
                          fontSize: 13,
                          color: '#382e27'
                        }}
                      >
                        <span>
                          {parcelaSelecionada}x de{' '}
                          {formatarPreco(
                            preco / parcelaSelecionada
                          )}
                        </span>

                        <FaAngleDown />
                      </div>

                      {visivel && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            zIndex: 100,
                            background: '#fff',
                            border: '1px solid #ddd4ca',
                            borderRadius: 9,
                            boxShadow:
                              '0 10px 30px rgba(52,41,33,0.12)',
                            padding: 6,
                          }}
                          onClick={(e) =>
                            e.stopPropagation()
                          }
                        >
                          {opcoes.map((opcao) => (
                            <div
                              key={opcao}
                              onClick={() => {
                                setParcelaSelecionada(opcao);
                                setParcelaHover(null);
                                setVisivel(false);
                                setOpcaoDeParcela(opcao);
                              }}

                              onMouseEnter={() => {
                                setParcelaHover(opcao);
                              }}

                              onMouseLeave={() => {
                                setParcelaHover(null);
                              }}

                              style={{
                                padding: '8px 9px',
                                fontSize: 12,
                                cursor: 'pointer',
                                borderRadius: 6,
                                backgroundColor:
                                  parcelaHover !== null
                                    ? opcao === parcelaHover
                                      ? '#f1ebe4'
                                      : 'transparent'
                                    : opcao === parcelaSelecionada
                                      ? '#f1ebe4'
                                      : 'transparent',
                              }}
                            >
                              {opcao}x de{' '}
                              {formatarPreco(
                                preco / opcao
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {Number(
                  String(
                    produto1?.categoria_id ?? ''
                  ).trim()
                ) !== 5 &&
                  Array.isArray(
                    produto1?.tamanhos
                  ) &&
                  produto1.tamanhos.length > 0 && (
                    <>
                      <div
                        style={{
                          height: 1,
                          background: '#e4ddd5',
                          margin: '20px 0 17px'
                        }}
                      />

                      <div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            marginBottom: 10,
                            color: '#342a23'
                          }}
                        >
                          Tamanho total

                        </div>

                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns:
                              isMobile
                                ? 'repeat(2, minmax(0,1fr))'
                                : 'repeat(4, minmax(0,1fr))',
                            gap: 8,
                          }}
                        >
                          {produto1.tamanhos.map(
                            (tamanho) => {
                              const tamanhoNum =
                                Number(tamanho);

                              const selecionado =
                                Number(
                                  tamanhoSelecionado
                                ) === tamanhoNum;

                              return (
                                <button
                                  key={tamanhoNum}
                                  type="button"
                                  onClick={() =>
                                    handleSelecionarTamanho(
                                      tamanhoNum
                                    )
                                  }
                                  style={{
                                    minHeight: 48,
                                    borderRadius: 8,
                                    border:
                                      selecionado
                                        ? '1.5px solid #5f4738'
                                        : '1px solid #ddd5cc',
                                    background:
                                      selecionado
                                        ? '#f1ece6'
                                        : '#fff',
                                    padding:
                                      '10px 8px',
                                    cursor: 'pointer',
                                    color: '#3b3028',
                                    textAlign:
                                      'center',
                                    fontSize: 12,
                                    fontWeight:
                                      selecionado
                                        ? 600
                                        : 500,
                                  }}
                                >
                                  {(tamanhoNum / 100).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} m
                                </button>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </>
                  )}

                <div
                  style={{
                    height: 1,
                    background: '#e4ddd5',
                    margin: '20px 0 17px'
                  }}
                />

                <button
                  type="button"
                  onClick={
                    handleAdicionarAoOrcamento
                  }
                  style={{
                    width: '100%',
                    marginTop: 22,
                    minHeight: 54,
                    border: '1px solid #5a4336',
                    borderRadius: 8,
                    background: '#634a3b',
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: 15,
                    fontWeight: 400,
                    letterSpacing: '0.01em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                    boxShadow:
                      '0 8px 22px rgba(77,57,45,0.13)',
                  }}
                >
                  <BsBagCheck
                    style={{
                      fontSize: 19
                    }}
                  />

                  Adicionar ao Carrinho
                </button>

                <button
                  type="button"
                  onClick={handleComprarAgora}
                  style={{
                    width: '100%',
                    marginTop: 10,
                    minHeight: 54,
                    border: '1px solid #634a3b',
                    borderRadius: 8,
                    background: '#fff',
                    color: '#634a3b',
                    cursor: 'pointer',
                    fontSize: 15,
                    fontWeight: 500,
                    letterSpacing: '0.01em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                    boxSizing: 'border-box',
                  }}
                >
                  Comprar agora
                </button>

                {precoPixEstimado !== null && (
                  <div style={{ marginTop: 12 }}>
                    <button
                      type="button"
                      onClick={() => setMostrarDetalhesPix((aberto) => !aberto)}
                      aria-expanded={mostrarDetalhesPix}
                      aria-label="Ver detalhes da oferta Pix com 10% de desconto"
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 12,
                        boxSizing: 'border-box',
                        border: '1px solid #d3c4b3',
                        borderRadius: 8,
                        background: '#f3eee8',
                        color: '#46382d',
                        textAlign: 'left',
                        cursor: 'pointer',
                      }}
                    >
                      <span style={{ flex: '1 1 116px', minWidth: 0 }}>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 8,
                          }}
                        >
                          <strong style={{ fontSize: 14, letterSpacing: '0.05em' }}>
                            PIX
                          </strong>
                          <span
                            style={{
                              padding: '4px 8px',
                              borderRadius: 999,
                              background: '#e0d2c0',
                              color: '#5f4738',
                              fontSize: 10,
                              fontWeight: 700,
                            }}
                          >
                            10% OFF
                          </span>
                        </span>
                        <span
                          style={{
                            display: 'block',
                            marginTop: 6,
                            fontSize: 12,
                            color: '#736458',
                          }}
                        >
                          Valor à vista no Pix
                        </span>
                      </span>

                      <span style={{ flex: '0 1 auto', minWidth: 0, textAlign: 'right' }}>
                        <strong
                          style={{
                            display: 'block',
                            fontFamily: 'Georgia, Times New Roman, serif',
                            fontSize: 23,
                            fontWeight: 400,
                            letterSpacing: '-0.02em',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {formatarPreco(precoPixEstimado)}
                        </strong>
                        <span style={{ fontSize: 11, color: '#736458' }}>
                          {mostrarDetalhesPix ? 'Ocultar detalhes' : 'Ver economia'}
                        </span>
                      </span>
                    </button>

                    {mostrarDetalhesPix && (
                      <p
                        style={{
                          margin: '8px 2px 0',
                          fontSize: 12,
                          lineHeight: 1.5,
                          color: '#736458',
                        }}
                      >
                        Economia estimada de{' '}
                        <strong>{formatarPreco(Number(preco) - precoPixEstimado)}</strong>.
                        O valor final do desconto deve ser confirmado na etapa de pagamento.
                      </p>
                    )}
                  </div>
                )}
              </aside>
            </section>

            <CaracteristicasProduto
              produto={produto1}
              imagemProduto={
                imagensProdutos[0] || imagemPrincipal
              }
              modulos={
                modulosDisponiveis
              }
              isMobile={isMobile}
              isTablet={isTablet}
              onOrcamento={() => {
                setOrcamentosSelecionados([]);
                setShowOrcamento(true);
              }}
            />

            <section
              style={{
                marginTop:
                  isMobile ? 30 : 38,
                padding:
                  isMobile
                    ? '20px 0 0'
                    : '24px 0 0',
                borderTop:
                  '1px solid #e7e0d8',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent:
                    'space-between',
                  gap: 18,
                  marginBottom: 14,
                }}
              >
                <h2
                  style={{
                    fontFamily:
                      'Georgia, Times New Roman, serif',
                    fontSize:
                      isMobile ? 24 : 28,
                    fontWeight: 400,
                    margin: 0,
                    color: '#2d251f',
                  }}
                >
                  Você também pode gostar
                </h2>

                {!isMobile && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 7
                    }}
                  >
                    <button
                      type="button"
                      onClick={handlePrev}
                      disabled={
                        imagemRelacionados.length <=
                        0
                      }
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: '50%',
                        border:
                          '1px solid #d9d0c7',
                        background: '#fff',
                        cursor: 'pointer',
                        color: '#5b4a3e',
                      }}
                    >
                      <SlArrowLeftCircle
                        style={{
                          fontSize: 18
                        }}
                      />
                    </button>

                    <button
                      type="button"
                      onClick={handleNext}
                      disabled={
                        imagemRelacionados.length <=
                        0
                      }
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: '50%',
                        border:
                          '1px solid #d9d0c7',
                        background: '#fff',
                        cursor: 'pointer',
                        color: '#5b4a3e',
                      }}
                    >
                      <SlArrowRightCircle
                        style={{
                          fontSize: 18
                        }}
                      />
                    </button>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    isMobile
                      ? 'repeat(2, minmax(0,1fr))'
                      : `repeat(${Math.min(
                        getImagesToShow()
                          .length || 1,
                        5
                      )}, minmax(0,1fr))`,
                  gap: isMobile
                    ? 10
                    : 13,
                }}
              >
                {imagemRelacionados.length >
                  0 ? (
                  getImagesToShow().map(
                    (item, idx) => (
                      <article
                        key={`${item.produto_id}-${startIndex}-${idx}`}
                        onClick={() => {
                          localStorage.setItem(
                            'produto_id',
                            item.produto_id
                          );

                          localStorage.setItem(
                            'categoria_id',
                            item.categoria_id
                          );

                          if (
                            typeof window !==
                            'undefined'
                          ) {
                            window.scrollTo(
                              0,
                              0
                            );
                          }

                          navigate(
                            `/produto/${item.produto_id}`
                          );
                        }}
                        style={{
                          cursor: 'pointer',
                          minWidth: 0,
                          background: '#fff',
                          border:
                            '1px solid #eee7df',
                          borderRadius: 8,
                          overflow: 'hidden',
                          transition:
                            'transform 180ms ease, box-shadow 180ms ease',
                        }}
                        onMouseEnter={(
                          e
                        ) => {
                          if (!isMobile) {
                            e.currentTarget.style.transform =
                              'translateY(-2px)';

                            e.currentTarget.style.boxShadow =
                              '0 10px 24px rgba(55,43,34,0.08)';
                          }
                        }}
                        onMouseLeave={(
                          e
                        ) => {
                          e.currentTarget.style.transform =
                            'translateY(0)';

                          e.currentTarget.style.boxShadow =
                            'none';
                        }}
                      >                        <div
                        style={{
                          width: '100%',
                          aspectRatio: '4 / 3',
                          background: '#f2efeb',
                          overflow: 'hidden'
                        }}
                      >
                          <ImageWithLoader
                            src={item.imagem_url}
                            alt={
                              item.produto_nome ||
                              item.produto_descricao ||
                              `Produto ${idx + 1}`
                            }
                            style={{
                              display: 'block',
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                          />
                        </div>

                        <div
                          style={{
                            padding: '9px 10px 11px'
                          }}
                        >
                          <div
                            style={{
                              fontSize: 12,
                              color: '#362d26',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {item.produto_nome || 'Royal Sofás'}
                          </div>

                          {item.preco_inicial != null &&
                            item.preco_inicial !== '' && (
                              <div
                                style={{
                                  marginTop: 4,
                                  fontSize: 10,
                                  color: '#80756b',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  gap: 8
                                }}
                              >
                                <span>
                                  {formatarPreco(
                                    item.preco_inicial
                                  )}
                                </span>

                                {item.tamanho_inicial_cm != null && (
                                  <span>
                                    {item.tamanho_inicial_cm} cm
                                  </span>
                                )}
                              </div>
                            )}
                        </div>
                      </article>
                    )
                  )
                ) : (
                  <p
                    style={{
                      color: '#82776d',
                      fontSize: 13
                    }}
                  >
                    Carregando produtos relacionados...
                  </p>
                )}
              </div>

              {isMobile &&
                imagemRelacionados.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      gap: 8,
                      marginTop: 14
                    }}
                  >
                    <button
                      type="button"
                      onClick={handlePrev}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        border: '1px solid #d9d0c7',
                        background: '#fff',

                        color: '#5b4a3e',
                        cursor: 'pointer',
                      }}
                    >
                      ‹
                    </button>

                    <button
                      type="button"
                      onClick={handleNext}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        border: '1px solid #d9d0c7',
                        background: '#fff',
                        color: '#5b4a3e',
                        cursor: 'pointer',
                      }}
                    >
                      ›
                    </button>
                  </div>
                )}
            </section>

          </main>

          <Footer />
        </>
      )}
    </div>
  );
}
